//#region Styles
import { Row, TitleSection } from "components/styles";
//#endregion
//#region Components
import PageManager from "components/PageManager/PageManager";
//#endregion
//#region Utils
import { RESOURCE_TEXT_LIST } from "views/Recursos/ResourcesLibrary/utils/constants";
import { getFormattedCaption } from "components/PageManager/utils";
//#endregion

const FilterHeader = ({
    searchedFilters, 
    serviceList,
    paginator
}) => {
    const getCaption = () => {
        const { resourceTypeId, page } = searchedFilters;
        if (!resourceTypeId) return "";
        return `${getFormattedCaption({
            ...paginator.data,
            currentPage: page
        })} ${RESOURCE_TEXT_LIST[resourceTypeId].capital.plural} `;
    }
    const noRecords = serviceList.value?.length === 0;
    return (
        <Row width="100%">
            <TitleSection>Filtros de búsqueda</TitleSection>
            <PageManager 
                caption={getCaption()}
                isFreeCaption
                noPages={noRecords}
                dataPaginator={{
                    ...paginator.data,
                    setCurrentPage: page => {
                        paginator.movePage(page);
                        serviceList.triggerFilling();
                    }
                }}/>
        </Row>
    );
}

export default FilterHeader;